var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconRouting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2651_175456)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1528 5.90621L10.0992 5.70616L9.91986 5.6026L6.88878 3.8526L8.88878 0.388501L12.3529 2.3885L11.0779 4.59687L10.9779 4.77007L11.0249 4.96446L12.389 10.6018L12.5125 11.112L13.0161 10.9638L18.5802 9.32653L18.7721 9.27007L18.8721 9.09687L20.1471 6.8885L23.6112 8.8885L21.6112 12.3526L18.5801 10.6026L18.4008 10.499L18.2007 10.5527L12.7366 12.0168L12.5366 12.0704L12.433 12.2497L10.843 15.0037L10.6676 15.3074L10.8935 15.5757C11.5606 16.368 11.7037 17.513 11.1651 18.4459C10.4731 19.6443 8.94845 20.0529 7.74999 19.3609C6.55154 18.669 6.143 17.1443 6.83493 15.9459C7.37353 15.013 8.4366 14.5644 9.45631 14.7459L9.80161 14.8074L9.97698 14.5037L11.567 11.7497L11.6705 11.5704L11.6169 11.3703L10.1528 5.90621Z",
    stroke: "#6B6A69"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2651_175456"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRouting);
export default __webpack_public_path__ + "static/media/icon-routing.13b6387a52fb7c6d64e8046b7236a105.svg";
export { ForwardRef as ReactComponent };